import {
  SEARCH_ADDRESS_REQUEST_FAIL,
  SEARCH_ADDRESS_REQUEST_SUCCESS,
  RESET_ADDRESS_SEARCH
} from '../action.types'
import InitialState from '../initial.state'

export default (state = InitialState.searchAddress, action) => {
  switch (action.type) {
    case SEARCH_ADDRESS_REQUEST_SUCCESS:
      return [...action.payload]
    case SEARCH_ADDRESS_REQUEST_FAIL:
      return state
    case RESET_ADDRESS_SEARCH:
      return InitialState.searchAddress;
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/address/searchaddress.reducer.js